import { useState } from "react";
import { Navbar, Container, Button, Nav, Alert } from "react-bootstrap";
import { useAuth } from "../../firebaseContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faLaptop,
  faFolderOpen,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import logo2 from "../../Images/nca-logo-landscape-neg-clean-v3-1.png";

export default function NavbarComponent() {
  const [error, setError] = useState(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    setError("");
    try {
      await logout();
      navigate("/");
    } catch {
      setError("Failed to log out");
    }
  }

  return (
    <>
      <Navbar expand="lg" sticky="top" className="main-navbar shadow-sm">
        <Container fluid="lg" className="py-2">
          <Navbar.Brand
            as="span"
            role="button"
            onClick={() => navigate("/")}
            className="navbar-brand-link"
          >
            <img
              src={logo2}
              height={48}
              alt="NCA logo"
              className="navbar-logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-nav" className="border-0" />
          <Navbar.Collapse id="main-nav">
            <Nav className="ms-auto align-items-lg-center justify-content-lg-end w-100">
              <div className="nav-actions d-flex flex-column flex-lg-row gap-2 ms-lg-auto">
                <Button
                  variant="outline-light"
                  className="nav-btn nav-btn-forms"
                  onClick={() => navigate("/downloads")}
                >
                  <FontAwesomeIcon icon={faFolderOpen} className="me-2" />
                  Forms
                </Button>
                <Button
                  variant="outline-light"
                  className="nav-btn nav-btn-index"
                  onClick={() => navigate("/index")}
                >
                  <FontAwesomeIcon icon={faListUl} className="me-2" />
                  Index
                </Button>
                <Button
                  variant="light"
                  className="nav-btn nav-btn-profile"
                  onClick={() => navigate("/profile")}
                >
                  <FontAwesomeIcon icon={faLaptop} className="me-2" />
                  Profile
                </Button>
                <Button
                  variant="outline-light"
                  className="nav-btn"
                  onClick={handleLogout}
                >
                  <FontAwesomeIcon
                    icon={faArrowRightFromBracket}
                    className="me-2"
                  />
                  Log out
                </Button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {error && <Alert variant="danger">{error}</Alert>}
    </>
  );
}
